import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import {
  Box,
  Button,
  Divider,
  MenuItem,
  Modal, 
  TextField, 
  Typography
} from '@mui/material';

import LoadingButton from '../../../../../../components/buttons/Button';

import { 
  CreatePaymentCurrencyBIZcoreCC, 
  UpdatePaymentCurrencyBIZcoreCC
} from '../../../../../../redux/actions/business/core/currencyCloudActions';

import global from "../../../../../../global.scss";

const Data = {
  Currency: ""
};

const PaymentCurrenciesModal = ({
  open, 
  setOpen, 
  title,
  update,
  handleGet
}) => {
  const dispatch = useDispatch();
  const state = useSelector(state => state["business.core.cc"]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(Data);
  const [mode, setMode] = useState(1);

  const [currenciesList, setCurrenciesList] = useState([]);

  const handleClose = () => {

    setOpen(false);
    setFormData(Data);
    setMode(1);
  }

  useEffect(() => {
    try {
      if(open){
        if(update.defaultMode === 1){
          // mode = 1 - create payment currency
          setMode(1);
        }else if(update.defaultMode === 2){
          // mode = 2 - edit payment currency
          setMode(2);
          setFormData({
            ...formData,
            // the API nests the FK object; the select is keyed on its id
            Currency: update.ref_currency_id?.id || "",
          });
        }else{
          toast.error("Invalid modal");
          handleClose();
        }
      }
    } catch (err) {
      console.log(err);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  useEffect(() => {
    try {
      formatCurrenciesList(state.currenciesList.records || []);
    } catch (err) {}
  }, [state]);

  // Sorted by name — the raw API order is insertion order, which makes a
  // 250-entry dropdown unusable.
  const formatCurrenciesList = (list) => {
    setCurrenciesList([...list].sort((a, b) => (a.name || "").localeCompare(b.name || "")));
  };  

  // --------------- handle change ----------------
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    if(mode === 1){
      // create payment country
      let obj = {
        ref_currency_id: formData.Currency || "",
      };
      dispatch(CreatePaymentCurrencyBIZcoreCC(obj, setLoading)).then(() => {
        handleGet(setLoading).then(() => {
          handleClose();
        })
      });
    }else if(mode === 2){
      // update payment country
      let obj = {
        ref_currency_id: formData.Currency || "",
      };
      dispatch(UpdatePaymentCurrencyBIZcoreCC(update.id, obj, setLoading)).then(() => {
        handleGet(setLoading).then(() => {
          handleClose();
        })
      });
    }else{
      toast.error("Invalid modal");
      handleClose();
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Box className="flexCenterCenterRow"
        width={"100vw"} height={"100vh"}>
        <Box maxWidth={"sm"} className="modal">
          <Box width={"100%"}
            sx={{ padding: "15px"}}>
            <Typography variant='h6' 
              sx={{ color: global["primary"] }} mb={"20px"}>
              {title}
            </Typography>
            <Box 
              className="flexCenterSBRow"
              gap={"15px"}
              mb={"15px"}>
              <TextField 
                select
                label="CC Currency"
                fullWidth
                name="Currency"
                value={formData.Currency}
                onChange={handleChange}
                inputProps={{ maxLength: 64 }}
                >
                {
                  currenciesList.map((item, index) => (
                    <MenuItem
                      key={index}
                      value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))
                }
              </TextField>
            </Box>
          </Box>
          <Divider
            sx={{ backgroundColor: "rgba(44, 45, 47, 1)" }}/>
          <Box className="flexCenterFERow" sx={{ gap: "20px", margin: "15px"}}>
            <Button variant='text'
              onClick={handleClose}>
              Cancel
            </Button>
            <LoadingButton 
              variant='contained'
              loading={loading}
              disabled={!(formData.Currency !== "")}
              onClick={handleSubmit}>
              Submit
            </LoadingButton>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}

export default PaymentCurrenciesModal;